import { Button } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useConfirm } from "melco-shared-logic";
import { useResendEmail } from "../../hooks/licenses/useResendEmail";

type ResendEmailButtonProps = {
    serial_number: string;
};

export const ResendEmailButton: React.FC<
    ResendEmailButtonProps
> = ({ serial_number }) => {
    const { t } = useTranslation();

    const resendEmail = useResendEmail();

    const confirmDelete = useConfirm(
        async () => {
            await resendEmail(serial_number);


        },
        {
            translationPrefix: "licenses.basic.detail.resendemail"


        }
    );



    return (
        <Button
            key="resendemail"

            onClick={async () => {
                await confirmDelete();
            }}
            type="primary"
        >
            {t("licenses.basic.detail.resendemail.title")}
        </Button>
    );
};
